<template>
  <div class="mb-6" v-if="!hidden">
    <v-alert
      v-for="message in value"
      :key="message.id"
      :text="text"
      :dismissable="dismissable"
      :icon="scopedIcon"
      :color="scopedColor"
      v-bind="alertProps"
      v-on="$listeners"
    >
      {{ message }}
      <template v-for="slot in slots__" v-slot:[slot]>
        <slot :name="slot" />
      </template>
    </v-alert>
  </div>
</template>

<script>
import { VAlert } from "vuetify/lib";
import Util from "@/components/Util.js";
export default {
  mixins: [VAlert],
  data: () => ({
    slots__: ["append", "close", "prepend"],
  }),
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: true,
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "error",
    },
    icon: {
      type: [String, Boolean],
      default: undefined,
    },
    color: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    alertProps() {
      const _keys = [
        "value",
        "hidden",
        "text",
        "type",
        "dismissable",
        "icon",
        "color",
      ];
      return Util.filterProps(this, _keys);
    },
    scopedIcon() {
      let _icon;
      if (this.type === "error" || this.type === "info") {
        _icon = "mdi-information";
      } else if (this.type === "warning") {
        _icon = "mdi-alert";
      } else if (this.type === "success") {
        _icon = "mdi-check-circle";
      }
      return this.icon || _icon;
    },
    scopedColor() {
      let _color;
      if (this.type === "error") {
        _color = "feedback-error";
      } else if (this.type === "success") {
        _color = "feedback-success";
      } else if (this.type === "info") {
        _color = "feedback-info";
      } else if (this.type === "warning") {
        _color = "feedback-warning";
      }
      return this.color || _color;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-alert {
    font-size: 0.875rem;
    padding: 0.75rem 1rem;
    margin-bottom: 0.5rem;
    width: 350px;
    .v-alert__wrapper {
      .v-alert__icon {
        margin-right: 0.5rem;
      }
      .v-alert__content {
        text-align: left;
      }
    }
  }
}
</style>
